module.exports = __webpack_public_path__ + "img/b_LbNorm_left.fd92eb40.jpeg";